<template>
    <div class="newsarticle">
        <template v-if="this.Bulletins.length>0">
            <template v-for="(bulletin, index) in this.Bulletins" :key="index">
                <div class="container pt-5">
                    <div class="row">
                        <div class="col-md-12 p-3 h-150 ">
                            <div class="p-5rounded-3">
                                <h2><p class="heading"> {{bulletin.headline}}</p></h2>
                                <p class="postedon"> {{formateDate(bulletin.posted)}}</p>
                                <p>{{bulletin.body}}</p>
                                <a class="review" href="\NewsEvents">{{this.Back}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <div v-if="this.isEmpty">
            <div class="heading m-5">
                {{this.NoArticle}}
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import getEndPoint, { newsAPI } from '../../constants/api.config'
    import {noArticle,back} from '../../constants/labels.config'
    export default {
        name: "NewsArticle",
        data() {
            return {
                Bulletins: [],
                NoArticle:noArticle,
                Back:back,
                isEmpty:false,
            }
        },
        methods: {
            formateDate(date) {
                const event = new Date(date);
                const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                return event.toLocaleDateString(undefined, options);
            },
            getBulletins(data) {
                let b = [];
                if(data===undefined || data===null)
                    return b;                                
                data.forEach(element => {
                    b.push(
                        {
                            newsid: element.newsID,
                            headline: element.headline,
                            body: element.body,
                            posted: element.postDate
                        }
                    );
                });

                return b;
            },
            getParameterByName(name) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                return urlParams.get(name);
            }
        },
        mounted() {
            //axios.get(getEndPoint(newsAPI) + 'DealerLocationID=' + window.DEALER_LOCATION.dealerLocationID + "&Brand=" + this.getParameterByName('brand') + "&NewsID=" + this.getParameterByName('newsid'))
            axios.get(getEndPoint(newsAPI) + "&NewsID=" + this.getParameterByName('newsid'))
                .then((response) => (                    
                    this.Bulletins = this.getBulletins(response.data.data),
                    this.isEmpty=this.Bulletins.length<=0
                ))
                .catch((error) => console.log(error));
        }
    };
</script>